const MAX_URL_LENGTH = 2048;
/** `localhost`, the whole IPv4 loopback range (127/8) and the IPv6 loopback literal. */
const isLocalHost = (hostname: string): boolean => hostname === 'localhost' || hostname.startsWith('127.') || hostname === '[::1]';

/**
 * True for an absolute http(s) URL that points at a remote host.
 * Rejects other schemes (blob:, data:, file:), localhost/loopback hosts and oversized values.
 */
export function isValidRemoteUrl(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  const url = value.trim();
  if (!url || url.length > MAX_URL_LENGTH) return false;

  try {
    const { protocol, hostname } = new URL(url);
    return (protocol === 'http:' || protocol === 'https:') && hostname.length > 0 && !isLocalHost(hostname);
  } catch {
    return false;
  }
}
